define([
  'jquery',
  '../global/templateEngine',
  'jqmodal',
  'jquery-validation',
  '../widget/availability/widget'
], ($, tplEngine) => {
  // ///////////////////////////////////////
  // was inline addJsCode

  $(document).ready(() => {
    $('form').each(function each() {
      $(this).validate();
    });
  });

  // ///////////////////////////////////////
  // was the default main script
  //
  // Cufon.replace(
  //     '.boxes .boxTitle, .facetSelector h2, .tabTitle a, .footer h2, ' +
  //     '#menuTitle, #mainTitle, #contentMenuTitle, #footerTitle'
  // );

  $(document).ready(() => {
    const photoListImg = $('.photoList img');
    const divVideoImg = $('div.video img');
    const divVideo = $('div.video');

    $('.score').hover(function hoverIn() {
      $(this).find('.scoreCard').show();
    }, function hoverOut() {
      $(this).find('.scoreCard').hide();
    });

    $('#jqModal').jqm();

    if (divVideo.length > 0) {
      const videoPlayerTemplate = tplEngine.compile($('#videoPlayerTemplate').html());

      divVideo.each(function each() {
        const divIdData = $(this).attr('id').split('_');
        const width = $(this).css('width');
        let poster;

        if (typeof divIdData[2] !== 'undefined' && divIdData[1] !== divIdData[2]) {
          poster = `?id=${divIdData[2]}&width=${width}`;
        } else {
          poster = `${divIdData[1]}.png?width=${width}`;
        }

        $(this).html(videoPlayerTemplate({
          videoId: divIdData[1],
          poster
        }));
      });
    }

    if (divVideoImg.length > 0) {
      const videoPlayerOverlayTemplate = tplEngine.compile($('#videoPlayerOverlayTemplate').html());

      divVideoImg.each(function each() {
        $(this).click(function click() {
          const id = $(this).attr('id').split('_').pop();
          const jqModal = $('#jqModal');
          jqModal.html(videoPlayerOverlayTemplate({ videoId: id }));
          $('.closeJqmModal img').click(() => {
            jqModal.jqmHide();
          });
          jqModal.jqmShow();
        });
      });
    }

    if (photoListImg.length > 0) {
      photoListImg.each(function each() {
        $(this).click(function click() {
          $('#jqModal').html(`<img alt="" src="${$(this).parents('a').attr('href')}" />`).jqmShow();
          return false;
        });
      });
    }

    $('input[name=typeOfAanvraag]').change(function change() {
      if ($(this).val() === '1') {
        $('#brochureTypePostWrapper').hide();
        $('#brochureType_email').prop('checked', 'checked');
      } else {
        $('#brochureTypePostWrapper').show();
      }
    });
  });

  const createCarousel = ($items, timeout = 5000) => {
    let mtTimeout;
    const Carousel = {
      timeout: timeout, // 15s @todo depending on client requirements
      index: 0,
      init() {
        // do we have carousel items
        if ($items.length === 0) {
          return;
        }
        // the click event is on any overlaying items
        // the overlay may have it's own links which will be honoured above this click
        $items.css("cursor", "pointer").click(() => {
          if ($items.eq(Carousel.index).data("link") !== "") {
            document.location = $items.eq(Carousel.index).data("link");
          }
        });
        // do we have a carousel (at least two images)
        if ($items.length <= 1) {
          return;
        }
        // hide all
        $items.hide();
        // show the first should be instantaneous as the current banner image is the same
        $items.eq(Carousel.index).show();
        // timeout to the next item
        timeoutTillNext($items.eq(Carousel.index));
      },
      next() {
        // do we have a carousel (at least two images)
        if ($items.length <= 1) {
          return;
        }
        clearTimeout(mtTimeout);
        $items.eq(Carousel.index).fadeOut(1750);
        // eslint-disable-next-line no-plusplus
        Carousel.index++;
        if (Carousel.index === $items.length) {
          Carousel.index = 0;
        }
        $items.eq(Carousel.index).fadeIn(1700);

        timeoutTillNext($items.eq(Carousel.index));
      },
      prev() {
        // do we have a carousel (at least two images)
        if ($items.length <= 1) {
          return;
        }
        clearTimeout(mtTimeout);
        $items.eq(Carousel.index).fadeOut(1750);
        Carousel.index--;
        if (Carousel.index < 0) {
          Carousel.index = $items.length - 1;
        }
        $items.eq(Carousel.index).fadeIn(1700);

        timeoutTillNext($items.eq(Carousel.index));
      }
    };

    const timeoutTillNext = currentElement => {
      // Go to next carousel-item after the video has ended or after X seconds
      const video = $(currentElement).find("video");
      if (video.length > 0) {
        video[0].addEventListener("ended", () => {
          Carousel.next();
          video[0].load();
        });
        return;
      }
      mtTimeout = setTimeout(Carousel.next, Carousel.timeout);
    };

    Carousel.init(); // so do it already
    return Carousel;
  };

  $(document).ready(() => {
    createCarousel($(".containerImage .carousel-item"));

    $(".carousel-soundControl").on("click", e => {
      const muteButton = $(e.currentTarget);
      const video = $(`video#${muteButton.data("targetid")}`)[0];

      video.muted = !video.muted;
      muteButton.find("i").toggleClass("fa-volume-off fa-volume-up");
      return false;
    });

    const $productListCarousels = $(".productList .carousel");

    $(".productList a").on("click", e => {
      const $target = $(e.target);
      let $button = $target;

      if ($target.localName !== "button") {
        const $buttons = $target.parents("button");
        $button = $buttons.length ? $($buttons[0]) : $target;
      }

      if ($button.hasClass("carousel-control")) {
        e.preventDefault();
        return false;
      }
    });

    $productListCarousels.map((_, element) => {
      const $carousel = $(element);
      const Carousel = createCarousel($carousel.find(".carousel-item"));

      $carousel.find("button").on("click", e => {
        if ($(e.target).data("slide") === "prev") {
          Carousel.prev();
          return;
        }
        Carousel.next();
      });
    });
  });

  const $tabNav = $("#nav-tab");
  const $tabContent = $("#nav-tabContent");

  $tabContent.find("a").on("click", function(e) {
    const targetHash = e.target.hash;

    if (targetHash.indexOf("#") !== 0) {
      return true;
    }

    const $targetTab = $tabNav.find(`a[href="${targetHash}"]`);
    const $currentActive = $tabNav.find(".active");

    if ($targetTab.length === 0 || $currentActive === $targetTab) {
      return true;
    }

    e.preventDefault();
    $currentActive.removeClass("active").attr("aria-selected", false);
    $targetTab.addClass("active").attr("aria-selected", true);

    $tabContent.find(".tab-pane.active").removeClass("active show");
    $tabContent.find(targetHash).addClass("active show");
    return false;
  });
});
